import { Mapper } from "../../../../base/utils/mapper";
import { StateProspectFollowupModel } from "../../../../domain/models/configuration/state-prospect-followup.model";
import { StateProspectFollowupEntity } from "../entities/state-prospect-followup.entity";

export class StateProspectFollowupImplementationRepositoryMapper extends Mapper<StateProspectFollowupEntity, StateProspectFollowupModel> {
    mapFrom(param: StateProspectFollowupEntity): StateProspectFollowupModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: StateProspectFollowupModel): StateProspectFollowupEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}